/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Agent_Piranha_LaughInputs */

const fr_legal_agent_piranha_laugh = /** @type {(inputs: Legal_Agent_Piranha_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-ins récents`)
};

/**

* @param {Legal_Agent_Piranha_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const legal_agent_piranha_laugh = /** @type {((inputs?: Legal_Agent_Piranha_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Agent_Piranha_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_legal_agent_piranha_laugh(inputs)
});